import React, { useState, useEffect, useRef } from "react"
import { Col, Form, Row, Tab, Tabs, Button, ButtonGroup } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import {
  capitalizeFirstLetter,
  getType,
  numberFormat,
  selectDropdownStyle,
} from "../../Helpers/Utils/Common"
import { searchInventory } from "../../Helpers/apiCalls/Inventory/ItemListApi"
import { refreshPage } from "../../Helpers/Utils/Common"
import Select from "react-select"
import downloadIcon from "../../Assets/Images/download_icon.png"
//components
import Navbar from "../../Components/Navbar/Navbar"
import Table from "../../Components/TableTemplate/Table"
import Delete from "../../Components/Modals/DeleteModal"
import EditModal from "../../Components/Modals/EditModal"
import * as XLSX from "xlsx"

//css
import "./Inventory.css"
import "../../Components/Navbar/Navbar.css"
import { getAllBranches } from "../../Helpers/apiCalls/Manage/Branches"
import { getCategory } from "../../Helpers/apiCalls/categoryApi"
import { getBrand } from "../../Helpers/apiCalls/brandsApi"
import Footer from "../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination"

export default function ItemLists() {
  let navigate = useNavigate()
  const userType = getType()
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [itemList, setItemList] = useState([])
  const [classificationOptions, setClassificationOptions] = useState([])
  const selectedBranch = "1"
  const [selectedAction, setSelectedAction] = useState("")
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const [brand, setBrand] = useState([])
  const [excelData, setExcelData] = useState([])
  const xlsxHeaders = [
    "ITEM",
    "BARCODE",
    "CUR QTY",
    "UNIT",
    "FLOAT QTY",
    "PO",
    "MIN",
    "MAX",
    "CLASSIFICATION",
  ]

  const [filterConfig, setFilterConfig] = useState({
    branch_id: "",
    name: "",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  function ViewPayment(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={() => handleViewPayment(row.id, row.api_link)}
      >
        Adjust
      </button>
    )
  }

  function handleViewPayment(id, type) {
    navigate("/itemlists/branch-adjustment/" + id)
  }

  function handleViewPO(po_id, shopType) {
    window.open("purchaseorders/review/1/" + po_id, "_blank")
  }

  function OngoingPOBadges(row, type) {
    return (
      <ButtonGroup vertical>
        <>
          {row.ongoing_po?.map((po) => {
            return (
              <button
                type="button"
                className="button-secondary table-button me-3 p-2"
                onClick={() => handleViewPO(po.id, type)}
                // onClick={() => handleViewContract(row.id, row.payment_mode)}
              >
                {`PO-${po.id}`}
              </button>
              // <Button
              //   className=""
              //   variant="outline-warning"
              //   size="sm"
              //   onClick={() => handleViewPO(po.id, type)}
              // >{`PO-${po.id}`}</Button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        value={selectedAction}
        id={row.id}
        onChange={(e) => handleSelectChange(e, row, type)}
      >
        <option value="" selected hidden>
          Select
        </option>
        <option value="adjust-po" className="color-options">
          Adjust
        </option>
        <option value="history-po" className="color-options">
          History
        </option>
        <option value="details-po" className="color-options">
          Item Details
        </option>
      </Form.Select>
    )
  }

  function handleSelectChange(e, row, type) {
    if (e.target.value === "edit-ps") {
      navigate("/paysuppliers/edit/" + e.target.id + "/" + e.target.role)
    } else if (e.target.value === "adjust-po") {
      navigate("/itemlists/branch-adjustment/" + e.target.id)
    } else if (e.target.value === "history-po") {
      window.open(
        "/itemlists/history/" +
          row.branch_id +
          "/" +
          row.item_id +
          "/" +
          row.item_unit_id +
          "/" +
          row.unit,
        "_blank"
      )
    } else if (e.target.value === "details-po") {
      navigate("/itemlists/itemdetails/" + row.item_id)
    }

    setSelectedAction("")
  }

  const [branches, setBranches] = useState([])
  const [branch, setBranch] = useState({})
  const [branchOptions, setBranchOptions] = useState([])

  useEffect(() => {
    var currentBranch = {}
    setBranchOptions(
      branches.map((_branch) => {
        var retval = { label: _branch.name, value: _branch.id }
        if (userType === "commissary_officer") {
          if (_branch.id === "1" || _branch.id === "5") {
            retval["disabled"] = true
          }
        } else {
          retval["disabled"] = false
        }
        if (_branch.id === filterConfig.branch_id) {
          currentBranch = { ...retval }
        }
        return retval
      })
    )
    setBranch(currentBranch)
  }, [branches])

  function handleBranchChange(e) {
    setFilterConfig((prev) => {
      return {
        ...prev,
        branch_id: e.value,
        branch_item_value: {
          label: e.label,
          value: e.value,
        },
      }
    })
    // setBranch(e);
    // const toFilter = { target: { name: "branch_id", value: e.value } };
    // handleFilterChange(toFilter);
  }

  async function fetchAllBranches() {
    setShowLoader(true)
    const response = await getAllBranches()

    if (response.data) {
      var allBranches = response.data.data.data
      // .filter((data) => {
      //   return data.is_franchise === "3";
      // });
      setBranches(allBranches)
      var defaultBranch = allBranches.filter((data) => {
        return data.name === "WAREHOUSE"
      })
      setFilterConfig((prev) => {
        return {
          ...prev,
          branch_id: defaultBranch ? defaultBranch[0].id : "1",
          branch_item_value: {
            label: defaultBranch ? defaultBranch[0].name : "",
            value: defaultBranch ? defaultBranch[0].id : "",
          },
        }
      })
    }
    setShowLoader(false)
  }

  function handleFilterChange(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  async function fetchFilteredItemLists() {
    setShowLoader(true)
    setExcelData([])
    setItemList([])
    setTotalItems(0)
    const response = await searchInventory(filterConfig)
    if (response.data) {
      var items = []
      response.data?.data?.map((PO) => {
        var info = PO
        info.current_qty = PO.current_qty
          ? parseInt(PO.current_qty)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : ""
        info.floating_qty = PO.floating_qty ? numberFormat(PO.floating_qty) : 0
        info.min = PO.min
          ? parseInt(PO.min)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : ""
        info.max = PO.max
          ? parseInt(PO.max)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : ""
        info.unit_to_name = PO.unit_to_name
        info.ongoing_po_data = PO?.ongoing_po
          ? PO?.ongoing_po
              .map((data) => {
                return `PO-${data.id}`
              })
              .join(", ")
          : ""
        info.critical_level = "1"
        info.action = ""
        info.api_link = ""
        info.classification = PO.category_name
          ? PO.subcategory_name
            ? PO.category_name + " - " + PO.subcategory_name
            : PO.category_name
          : ""
        // info.item_type = capitalizeFirstLetter(PO.item_type.replace("_", " "));
        items.push(info)
      })
      setItemList(items)

      var excel = items.map((bill) => {
        var info = {}
        info.item_name = bill.item_name
        info.barcode = bill.barcode
        info.current_qty = bill.current_qty
        info.unit_to_name = bill.unit_to_name
        info.floating_qty = bill.floating_qty
        info.ongoing_po_data = bill.ongoing_po_data
        info.min = bill.min
        info.max = bill.max
        info.classification = bill.classification
        return info
      })
      setExcelData(excel)
      setTotalItems(response.data.size)
    }
    setShowLoader(false)
  }

  const handleTabSelect = (key) => {
    setFilterConfig((prev) => {
      return { ...prev, shop: key }
      // return { ...prev, shop: key, branch_id: "1" };
    })
  }

  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.value = category.id
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
      //subcategories
      var subcategories = response.data.subcategories.map((category) => {
        var info = {}
        info.value = category.subname
        info.label = category.subname
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)
    }
  }

  async function fetchBrands() {
    const response = await getBrand({})
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.value = brand.name
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands)
    }
  }

  function handleExport() {
    const rows = excelData

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "Itemlist.xlsx", { compression: true })
  }

  useEffect(() => {
    fetchAllBranches()
    fetchCategories()
    fetchBrands()
  }, [])

  useEffect(() => {
    if (filterConfig.branch_id !== "") {
      fetchFilteredItemLists()
    }
  }, [filterConfig, currentPage])

  useEffect(() => {
    var subcat = subCategories.filter((data) => {
      return data.category_id === filterConfig?.category_id
    })
    setFilteredSubCategories(subcat)
  }, [filterConfig.category])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WH INVENTORY"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={6}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              ITEMS LIST{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              className="search-bar"
              placeholder="Search item anything"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            ></input>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3 mt-2 mt-lg-0"
          >
            <Select
              className="dropsearch-filter py-0 w-100"
              classNamePrefix="react-select"
              value={filterConfig.branch_item_value}
              // styles={selectDropdownStyle}
              options={branchOptions}
              onChange={handleBranchChange}
            />
          </Col>
        </Row>
        <div>
          <div className="tab-content">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Category"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_category}
                  options={[
                    { label: "All Categories", value: "" },
                    ...categories,
                  ]}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        category: e.label,
                        category_id: e.value,
                        selected_category: {
                          value: e.value,
                          label: e.label,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Brand"
                  styles={selectDropdownStyle}
                  value={filterConfig.selected_brand}
                  options={[{ label: "All Brands", value: "" }, ...brand]}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        brand: e.value,
                        selected_brand: {
                          value: e.value,
                          label: e.label,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="sales_type"
                  value={filterConfig.sales_type}
                  className="date-filter force-width w-full"
                  onChange={(e) => handleFilterChange(e)}
                >
                  <option value="" selected>
                    All Sales Type
                  </option>
                  <option value="retail">Retail</option>
                  <option value="wholesale">Wholesale</option>
                  <option value="universal">Both</option>
                </Form.Select>
              </Col>
            </Row>
            <div className="mb-2" />

            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ITEM",
                "ITEM CODE",
                "CUR QTY",
                "UNIT",
                "PO",
                "MIN",
                "MAX",
                "CATEGORY",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "item_name",
                "item_code",
                "current_qty",
                "unit",
                "__ongoing_po_badges__",
                "min",
                "max",
                "classification",
              ]}
              tableData={itemList}
              ViewBtn={(row) => ViewPayment(row)}
              ActionBtn={(row) => ActionBtn(row, "")}
              OngoingPOBadges={(row) => OngoingPOBadges(row, "")}
              showLoader={showLoader}
              tableType="itemList"
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
          <div />
        </div>
        <div className="mb-3" />
        <br />
        <br />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>
      <Footer />
    </div>
  )
}
